import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useSyncLogs } from '@/hooks/use-eirsaliye';
import { ChevronDown, ChevronUp, Clock, CheckCircle, XCircle, AlertTriangle } from 'lucide-react';

function statusIcon(status: string) {
  switch (status) {
    case 'success':
      return <CheckCircle className="w-4 h-4 text-green-600" />;
    case 'partial':
      return <AlertTriangle className="w-4 h-4 text-orange-600" />;
    case 'failed':
      return <XCircle className="w-4 h-4 text-red-600" />;
    case 'running':
      return <Clock className="w-4 h-4 text-blue-600 animate-pulse" />;
    default:
      return <Clock className="w-4 h-4 text-muted-foreground" />;
  }
}

function statusLabel(status: string) {
  switch (status) {
    case 'success': return 'Basarili';
    case 'partial': return 'Kismi';
    case 'failed': return 'Basarisiz';
    case 'running': return 'Calisiyor';
    default: return status;
  }
}

export function SyncLogSection() {
  const [isOpen, setIsOpen] = useState(false);
  const { data: logs, isLoading } = useSyncLogs();

  return (
    <Card>
      <CardHeader className="pb-0 cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium flex items-center gap-2">
            <Clock className="w-4 h-4" />
            Senkronizasyon Gecmisi
            {logs?.length ? (
              <Badge variant="secondary" className="text-xs ml-1">{logs.length}</Badge>
            ) : null}
          </CardTitle>
          <Button variant="ghost" size="sm">
            {isOpen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
          </Button>
        </div>
      </CardHeader>
      {isOpen && (
        <CardContent className="pt-3">
          {isLoading ? (
            <p className="text-sm text-muted-foreground">Yukleniyor...</p>
          ) : !logs?.length ? (
            <p className="text-sm text-muted-foreground">Henuz senkronizasyon yapilmadi.</p>
          ) : (
            <div className="space-y-2">
              {logs.map((log) => (
                <div
                  key={log.id}
                  className="flex items-center justify-between p-2 rounded bg-muted/30 text-sm"
                >
                  <div className="flex items-center gap-2">
                    {statusIcon(log.status)}
                    <div>
                      <span className="font-medium">{statusLabel(log.status)}</span>
                      <span className="text-xs text-muted-foreground ml-2">
                        {new Date(log.started_at).toLocaleString('tr-TR')}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-muted-foreground">
                    <span>{log.emails_found} email</span>
                    <span>{log.emails_processed} islendi</span>
                    <span className="font-medium text-foreground">{log.irsaliyes_created} irsaliye</span>
                    {log.errors?.length > 0 && (
                      <Badge variant="destructive" className="text-[10px]">{log.errors.length} hata</Badge>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
}
